import TasksListWrapper from "../components/tasks-list";
import MeTaskFilters from "./filters";

export default function MeTasks({ status }) {
  return (
    <TasksListWrapper
      status={status}
      basePath="/tasks/me"
      storageKeyPrefix="me"
      baseFilters={{ assignee: { user: { _eq: "$CURRENT_USER" } } }}
      showAssigneeColumn={false}
      renderFilters={MeTaskFilters}
    />
  );
}
